import request from '@/utils/request'

// 获取排队列表
export function getList(data) {
  return request.get('/truckQueue/list')
}

// 添加排队信息
export function createOne(data) {
  return request.post('/truckQueue/insert', data)
}

// 更新排队信息
export function updateOne(data) {
  return request.post('/truckQueue/jump', data)
}

// 删除排队信息
export function deleteOne(params) {
  return request.get('/truckQueue/delete', { params })
}
